// @flow strict

import type {Holidays, Holiday} from 'src/types/scheduler/holidays.js';

// $FlowFixMe[nonstrict-import]
import type {Dispatch, ThunkAction} from 'src/reducers';

// $FlowFixMe[nonstrict-import]
import * as reduxApi from 'src/utils/redux-api-v2';

// $FlowFixMe[untyped-import]
import {camel, snake} from 'src/utils';


export const SET_HOLIDAYS = 'SET_HOLIDAYS';
export const ADD_HOLIDAY = 'ADD_HOLIDAY';
export const EDIT_HOLIDAY = 'EDIT_HOLIDAY';
export const REMOVE_HOLIDAY = 'REMOVE_HOLIDAY';

export type SchedulerHolidayActions =
  | SetHolidays
  | AddHoliday
  | EditHoliday
  | RemoveHoliday;

export type SetHolidays = {
  type: typeof SET_HOLIDAYS,
  payload: Holidays,
};

export type AddHoliday = {
  type: typeof ADD_HOLIDAY,
  payload: Holiday,
};

export type EditHoliday = {
  type: typeof EDIT_HOLIDAY,
  payload: Holiday,
};

export type RemoveHoliday = {
  type: typeof REMOVE_HOLIDAY,
  payload: string,
};

export const setHolidays = (payload: Holidays): SetHolidays => ({
  type: SET_HOLIDAYS,
  payload,
});

export const addHoliday = (payload: Holiday): AddHoliday => ({
  type: ADD_HOLIDAY,
  payload,
});

export const editHoliday = (payload: Holiday): EditHoliday => ({
  type: EDIT_HOLIDAY,
  payload,
});

export const removeHoliday = (payload: string): RemoveHoliday => ({
  type: REMOVE_HOLIDAY,
  payload,
});

export const fetchHolidays =
  (): ThunkAction<> => async (dispatch: Dispatch) => {
    try {
      const holidays: Holidays = await dispatch(
        reduxApi.get('scheduler/holiday-configs'),
      );
      dispatch(setHolidays(camel(holidays)));
    } catch (error) {
      throw error;
    }
  };

export const createHoliday =
  (payload: {
    title: string,
    holidayDate: string,
    securityGroupIds: string[],
  }): ThunkAction<> =>
  async (dispatch: Dispatch) => {
    try {
      const holiday: Holiday = await dispatch(
        reduxApi.post('scheduler/holiday-configs', {
          ...snake(payload),
        }),
      );
      dispatch(addHoliday(camel(holiday)));
    } catch (error) {
      throw error;
    }
  };

export const updateHoliday =
  (payload: Holiday): ThunkAction<> =>
  async (dispatch: Dispatch) => {
    const {id, ...rest} = payload;
    try {
      const holiday: Holiday = await dispatch(
        reduxApi.put(`scheduler/holiday-config/${id}`, {
          ...snake(rest),
        }),
      );
      dispatch(editHoliday(camel(holiday)));
    } catch (error) {
      throw error;
    }
  };

export const deleteHoliday =
  (id: string): ThunkAction<> =>
  async (dispatch: Dispatch) => {
    try {
      await dispatch(reduxApi.del(`scheduler/holiday-config/${id}`));
      dispatch(removeHoliday(id));
    } catch (error) {
      throw error;
    }
  };
